module.exports = __webpack_public_path__ + "static/media/imageColaborador4.7f791e4f.png";